import * as React from 'react';
import parse from 'html-react-parser';
import './style.scss';

const InfoCard = props => {
  return (
    <div className="info-card" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
      <h3 className="info-card-title">{props.title}</h3>
      <p>{parse(props.content)}</p>
    </div>
  );
};

export default InfoCard;
